export const WarningIcon = ({ color, secondaryColor }: { color: string; secondaryColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            version="1.1"
            id="svg1"
            xmlns="http://www.w3.org/2000/svg"
            style={{ fill: color }}
        >
            <ellipse
                style={{ fill: secondaryColor || "transparent", strokeWidth: "1.29174" }}
                id="path2"
                cx="9.8728819"
                cy="10.042373"
                rx="6.9067798"
                ry="6.4830508"
            />
            <path
                d="M10.0001 1.66663C5.40008 1.66663 1.66675 5.39996 1.66675 9.99996C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6001 1.66663 10.0001 1.66663ZM10.0001 10.8333C9.54175 10.8333 9.16675 10.4583 9.16675 9.99996V6.66663C9.16675 6.20829 9.54175 5.83329 10.0001 5.83329C10.4584 5.83329 10.8334 6.20829 10.8334 6.66663V9.99996C10.8334 10.4583 10.4584 10.8333 10.0001 10.8333ZM10.8334 14.1666H9.16675V12.5H10.8334V14.1666Z"
                id="path1"
            />
        </svg>
    );
};
